export const FETCH_POKEDEX_REQUEST = "FETCH_POKEDEX_REQUEST"
export const FETCH_POKEDEX_SUCCESS = "FETCH_POKEDEX_SUCCESS"
export const FETCH_POKEDEX_ERROR = "FETCH_POKEDEX_ERROR"

export const SORT_POKEMONS = "SORT_POKEMONS"
